/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect } from "react";
import { ModalDialog, Form } from "@culturehq/components";
import ErrorMessage from "components/common/ErrorMessage";
import { useIsMobile, useIsLoggedIn } from "app/hooks";
import PostStoryFooter from "./PostStoryFooter";
import CropImage from "./CropImage";
import PostStoryVideoPreview from "./PostStoryVideoPreview";
import PostStoryLeftColumn from "./PostStoryLeftColumn";
import PostStoryPromptSelection from "./PostStoryPromptSelection";
import PostStoryRightColumn from "./PostStoryRightColumn";
import { usePostStoryContext } from "../../contexts/PostStoryContext";
import { isMediaVideoType } from "../../utils";

const PostStoryForm = () => {
  const isLoggedIn = useIsLoggedIn();
  const isMobile = useIsMobile();
  const {
    organization,
    state: {
      selectedMedia,
      showUnsplashSearch,
      error,
      currentBody,
      postingStory
    },
    editorRef,
    editorCopyRef,
    handleSubmit
  } = usePostStoryContext();

  useEffect(
    () => () => {
      // eslint-disable-next-line no-param-reassign
      editorCopyRef.current = editorRef.current;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentBody]
  );

  return (
    <ModalDialog.Body>
      {error && <ErrorMessage error={error} />}
      <Form className="form" onSubmit={handleSubmit}>
        <div className={`Form-Container ${postingStory ? "disabled" : ""}`}>
          <PostStoryPromptSelection />
          <PostStoryLeftColumn />
          <PostStoryRightColumn
            isMobile={isMobile}
            showUnsplashSearch={showUnsplashSearch}
            organization={organization}
          />
          {isMediaVideoType(selectedMedia as Blob) && isLoggedIn && (
            <PostStoryVideoPreview />
          )}
        </div>
        <PostStoryFooter />
      </Form>
      <CropImage />
    </ModalDialog.Body>
  );
};

export default PostStoryForm;
